import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { DeviceIcon } from '@/components/DeviceIcon';
import { MARKER_SIZE } from '@/lib/location';

// A small device marker placed on a location plan. Center handles (source +
// target) let derived connection edges attach center-to-center.
//
// The per-page element zoom (`data.scale`) scales ONLY the marker (icon box +
// label) — the background map and CAD frame stay fixed to the sheet. The marker
// grows from its top-left anchor, so its centre (where edges attach) is at
// position + size/2, matching the SVG/draw.io exporters.
export function LocationMarkerNode({ data, selected }) {
  const scale = data.scale || 1;
  const size = MARKER_SIZE * scale;
  const iconSize = (MARKER_SIZE - 10) * scale;
  const labelFont = Math.max(9, Math.round(10 * scale));
  return (
    <div className="flex flex-col items-center" style={{ width: size }} data-testid={`location-marker-${data.deviceId}`}>
      <div
        className={`flex items-center justify-center rounded-lg border bg-white shadow-sm transition-colors duration-150 ${
          selected ? 'border-[#0B5FFF] ring-2 ring-[#0B5FFF]/30' : 'border-[#1b232c]/40'
        }`}
        style={{ width: size, height: size }}
      >
        <DeviceIcon type={data.deviceType} size={iconSize} />
      </div>
      <div
        className="mt-1 max-w-[160px] truncate rounded bg-white/85 px-1 text-center font-semibold leading-tight text-[#111418] ring-1 ring-[#1b232c]/10"
        style={{ fontSize: labelFont }}
        title={data.label}
      >
        {data.label}
      </div>
      <Handle id="c" type="source" position={Position.Top} className="!h-2 !w-2 !border-0 !bg-transparent" style={{ left: size / 2, top: size / 2 }} />
      <Handle id="c" type="target" position={Position.Top} className="!h-2 !w-2 !border-0 !bg-transparent" style={{ left: size / 2, top: size / 2 }} />
    </div>
  );
}
